import { Component, Event, EventEmitter, Prop, Watch } from "@stencil/core";

@Component({
    tag: "ux-redirect",
    shadow: false
})
export class Redirect {
    /** timeoutID */
    private timeout: number;

    /** url string where the user should be redirected to */
    // @ts-expect-error Check for typing
    @Prop() readonly url: string = null;

    /** time until the redirect should occur in seconds */
    @Prop() readonly delay: number = 0;

    /** Emitted before the actual redirect takes place, includes the URL, can be cancelled  */
    @Event({ eventName: "uxRedirect", bubbles: true, cancelable: true })
    redirect!: EventEmitter<string>;

    private loadUrl() {
        const evt = this.redirect.emit(this.url);
        if (!evt.defaultPrevented) {
            window.location.href = this.url;
        }
    }

    @Watch("delay")
    public setDelay() {
        window.clearTimeout(this.timeout);
        this.timeout = window.setTimeout(this.loadUrl.bind(this), this.delay * 1000);
    }

    public componentDidLoad() {
        if (this.url === null) {
            return;
        }
        this.setDelay();
    }
}
